import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
Container.displayName = 'Container';
export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  &[data-disabled='true'],
  &[data-disabled='true'] > * {
    cursor: not-allowed;
  }
  position: relative;
`;
ContainerSidebar.displayName = 'ContainerSidebar';
export const Block = styled.div`
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  left: 0;
  top: 0;
  position: absolute;
  width: 330px;
  z-index: 9;
  cursor: auto;
`;
export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;

export const ButtonText = styled.div`
  color: ${beam.font.primary};
  display: flex;
  flex-direction: row;
  opacity: 1;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;

  border: 1px solid #e9edf1;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
`;
